module.exports = __webpack_public_path__ + "static/7-min-029eac6429338dc590485465f2fd38ad.jpg";